import { z } from 'zod';
import { ScheduledReportRuleSchema } from '../applications.schema';
import { StartDirectoryScanResponseSchema } from '../directory-scan/directory-scan.schema';

export const DynamicApplicationScanRunTriggerContractSchema = z.enum([
  'SCHEDULED',
  'MANUAL',
]);

export const DynamicApplicationScanRunStatusContractSchema = z.enum([
  'QUEUED',
  'RUNNING',
  'COMPLETED',
  'FAILED',
  'STOPPED',
]);

export const DynamicApplicationScanRunSchema = z.object({
  id: z.string(),
  scannerScanId: z.string(),
  trigger: DynamicApplicationScanRunTriggerContractSchema,
  credentialId: z.string().nullable(),
  status: DynamicApplicationScanRunStatusContractSchema,
  progressPercent: z.number().nullable(),
  findingsCount: z.number().int().nullable(),
  targetCount: z.number().int().nullable(),
  error: z.string().nullable(),
  startedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullable(),
});

export const DynamicApplicationScanAutomationConfigSchema = z.object({
  enabled: z.boolean(),
  scheduleRule: ScheduledReportRuleSchema.nullable(),
  credentialId: z.string().nullable(),
  vulnerabilityEnabled: z.boolean(),
  directoryEnabled: z.boolean(),
  hasUrl: z.boolean(),
  hasScanTargets: z.boolean(),
  isBackendOnly: z.boolean(),
});

export const DynamicApplicationScanAutomationResponseSchema = z.object({
  featureEnabled: z.boolean(),
  config: DynamicApplicationScanAutomationConfigSchema,
  nextRunAt: z.coerce.date().nullable(),
  activeRun: DynamicApplicationScanRunSchema.nullable(),
  lastRun: DynamicApplicationScanRunSchema.nullable(),
});

export const TriggerDynamicApplicationScanResponseSchema = z
  .object({
    run: DynamicApplicationScanRunSchema.optional(),
    directoryScan: StartDirectoryScanResponseSchema.optional(),
  })
  .refine((value) => value.run != null || value.directoryScan != null);

export const StopDynamicApplicationScanResponseSchema = z.object({
  message: z.string(),
  run: DynamicApplicationScanRunSchema.nullable(),
});
